/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import MUIDataTable from "mui-datatables";
import { styled, Paper, Stack, CircularProgress } from "@mui/material";
import PrintIcon from "@material-ui/icons/Print";
import DeleteIcon from "@material-ui/icons/Delete";
import DownloadIcon from "@material-ui/icons/GetApp";
import { fetchPayslip } from "@redux/actions";
import { useDispatch, useSelector } from "react-redux";
import DeletePaySlip from "@components/Modal/Payroll/DeletePaySlip";
import { PaySlipPrint } from "./PrintAble/PaySlipPrint";
import { getFullMonthNameWithYear } from "@utils/utils";
import { isEmpty } from "lodash";
import html2pdf from "html2pdf.js";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const PaySlip = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [deletedSlip, setDeletedSlip] = useState("");
  const paySlips = useSelector((state) => state.paySlips);

  const dispatch = useDispatch();
  const componentRef = useRef();

  const generatePDF = (employee_name) => {
    const element = document.getElementById('printContianer');
    html2pdf(element, {
      margin: 10,
      filename: `${employee_name} Pay Slip.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    });
  };

  const printData = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (isEmpty(paySlips)) {
      setIsLoading(true);
      dispatch(fetchPayslip()).then(() => setIsLoading(false));
    }
  }, []);

  const closeDeleteModel = () => {
    setDeleteModal(false);
  };

  const columns = [
    {
      name: "employee_name",
      label: "Employee Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "start_date",
      label: "Starting Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (params) => {
          return getFullMonthNameWithYear(params);
        },
      },
    },
    {
      name: "end_date",
      label: "Ending Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (params) => {
          return getFullMonthNameWithYear(params);
        },
      },
    },
    {
      name: "status",
      label: "Action",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <Stack direction="row" spacing={1}>
                <Item>
                  <PrintIcon
                    color="action"
                    cursor="pointer"
                    onClick={() => {
                      setSelected(paySlips[tableMeta.rowIndex]);
                      setTimeout(printData, 500);
                    }}
                  >
                    Print
                  </PrintIcon>
                </Item>
                <Item>
                  <DownloadIcon
                    color="action"
                    cursor="pointer"
                    onClick={()=>{
                      setSelected(paySlips[tableMeta.rowIndex]);
                      setTimeout(()=>generatePDF(paySlips[tableMeta.rowIndex].employee_name),500)
                    }}
                  >
                    Download
                  </DownloadIcon>
                </Item>
                <Item>
                  <DeleteIcon
                    color="action"
                    cursor="pointer"
                    onClick={() => {
                      setDeletedSlip(paySlips[tableMeta.rowIndex]._id)
                      setDeleteModal(true);
                    }}
                  >
                    Delete
                  </DeleteIcon>
                </Item>
              </Stack>
            </>
          );
        },
      },
    },
  ];

  if (isLoading) {
    return (
      <div className="LoaderWrapper">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <>
      <div className="mui-datadata-table">
        <MUIDataTable
          title={"Payslip"}
          options={{
            selectableRows: false,
            rowHover: false,
            filter: false,
            sort: false,
            print: false,
            download: false,
            responsive: "scroll",
          }}
          data={paySlips}
          columns={columns}
        />
      </div>
      {deleteModal && (
        <DeletePaySlip closeModel={closeDeleteModel} slip={deletedSlip} />
      )}
      <div className="row" style={{ display: "none" }}>
        <PaySlipPrint ref={componentRef} slipData={selected} />
      </div>
    </>
  );
};

export default PaySlip;
